import { useEffect, useState } from 'react';

export type ProfileOpenMode = 'new-tab' | 'modal';

const KEY = 'profile_open_mode';
const VARIANTS: ProfileOpenMode[] = ['new-tab', 'modal'];

function assign(): ProfileOpenMode {
    const stored = localStorage.getItem(KEY) as ProfileOpenMode | null;
    if (stored && VARIANTS.includes(stored)) return stored;

    // URL param override for manual QA / forcing a variant
    const param = new URLSearchParams(window.location.search).get('view') as ProfileOpenMode | null;
    if (param && VARIANTS.includes(param)) {
        localStorage.setItem(KEY, param);
        return param;
    }

    // Random assignment
    const variant = VARIANTS[Math.floor(Math.random() * VARIANTS.length)];
    localStorage.setItem(KEY, variant);
    return variant;
}

export function useProfileOpenMode(): ProfileOpenMode {
    const [mode, setMode] = useState<ProfileOpenMode>('new-tab');

    useEffect(() => {
        setMode(assign());
    }, []);

    return mode;
}
